import { Delay } from "../modules/types/intake-funnel";

export function getDelayFromHours(delayHours?: number): Delay | null {
  if (!delayHours) {
    return null;
  }

  switch (true) {
    case delayHours < 1:
      return "lt1";
    case delayHours >= 1 && delayHours < 2:
      return "gt1_lt2";
    case delayHours >= 2 && delayHours < 3:
      return "gt2_lt3";
    case delayHours >= 3 && delayHours < 4:
      return "gt3_lt4";
    case delayHours >= 4:
      return "gt4";
    default:
      return "never";
  }
}
